export const CHANGE_PASSWORD_ATTEMPT = 'CHANGE_PASSWORD_ATTEMPT';
export type CHANGE_PASSWORD_ATTEMPT = typeof CHANGE_PASSWORD_ATTEMPT;

export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export type CHANGE_PASSWORD_SUCCESS = typeof CHANGE_PASSWORD_SUCCESS;

export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export type CHANGE_PASSWORD_FAILURE = typeof CHANGE_PASSWORD_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/user/changePassword/Types.tsx